module.exports = {
      id: "icon-patients-usage",
      viewBox: "0 0 65 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-patients",
      toString: function () {
        return this.url;
      }
    }